<template>
  <div class="lookimg_main">
      <!-- :class="isroll?'main_tops fixation':'main_tops'" -->
      <div class="main_tops fixation" id="fixation">
        <nav-bar :lefticon="returnwhiteicon" :lefticonheight="1.4" :lefticonwidth="1.4"
            title="官方图片" titlecolor="#333333" @goback="goback">
            </nav-bar>
            <div class="type_box" id="type_boxid">
                <span :class="seekname=='全部'?'type_item active':'type_item'" @click="tab('全部')">全部 {{sum}}</span>
                <span :class="seekname==item.name?'type_item active':'type_item'" v-for="(item,index) in backups" :key="index" @click="tab(item.name)">{{item.name}} {{item.value.length}}</span>
            </div>
       </div>
       <div class="main_box" :style="index==0&&index==datainfo.length-1?'padding-top:'+belowHeight+'rem;padding-bottom: 8.5rem;':index==0?'padding-top:'+belowHeight+'rem;':index==datainfo.length-1?'padding-bottom: 8.5rem;':''" v-for="(item,index) in datainfo" :key="index">
           <p class="title">{{item.name}} {{item.value.length}}</p>
           <div class="imgbox" v-for="(items,indexs) in item.value" :key="indexs">
            <img :src="videoicon" class="videoplay" v-if="item.name=='视频'"/>
            <img :src="item.name=='视频'?items.ThumbnailPictureURL:items" class="main_img" @click="item.name=='视频'?videofy(item.value):magnify(item.value,items)"/>
          </div>
          <!-- :class="index==0&&index==datainfo.length-1&&client==10?'main_box main_boxs main_boxb':index==0&&index==datainfo.length-1&&client==11?'main_box main_boxss main_boxb':index==0&&client==10?'main_box main_boxs':index==0&&client==11?'main_box main_boxss':index==datainfo.length-1?'main_box main_boxb':'main_box'" v-for="(item,index) in datainfo" :key="index" -->
           <!-- <video :src="items.URL" 
            x5-video-player-type="h5" 
            x5-video-orientation="landscape"
            webkit-playsinline="true"
            playsinline="true" ref="video" class="main_img"
            v-for="(items,indexs) in item.value" :key="indexs" @click="videoshow=true"></video> -->
        <!-- <video :src="url" controls="controls" class="main_img" @click.stop="videoshow=true">
        </video> -->
        <!-- <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      >
        </video-player> -->
       </div>
       <div class="main_bottom">
           <div class="bottom_item">
               <p>¥<span class="num">{{raisePrice}}</span><span class="tip">起</span></p>
               <p @click="goback">查看更多价格</p>
           </div>
           <van-button type="default" @click="goback">查看房型</van-button>
       </div>
       <van-popup v-model="videoshow">
           <van-swipe @change="onChanges">
                <van-swipe-item>
                    <video-player
                    class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="false"
                    :options="playerOptions">
                    </video-player>
                </van-swipe-item>
                <van-swipe-item>2</van-swipe-item>
                <van-swipe-item>3</van-swipe-item>
                <van-swipe-item>4</van-swipe-item>
                <template #indicator>
                    <div class="custom-indicator"></div>
                </template>
            </van-swipe>
        </van-popup>
        <span class="close" @click="videoshow = false" v-if="videoshow">✖</span>
        <div class="videopop" v-if="videoshow">
            <span class="title">视频</span>
            <span class="page"><label>{{ current + 1 }}</label>/{{videototal}}</span>
        </div>
       <van-image-preview v-model="show" :images="images" :startPosition="startPosition" @change="onChange">
        <template v-slot:index><span class="title">{{typename[index]}}</span><span class="page"><label>{{index+1}}</label>/{{images.length}}</span></template>
        <template v-slot:cover>
            <div class="image-preview-close-btn">
                <span class="close" @click="show=false">✖</span>
            </div>
        </template>
        </van-image-preview>
  </div>
</template>

<script>
import navBar from "../components/nav-bar";
import { ImagePreview } from 'vant';
import {getOfficialimgData} from '../api';
export default {
    components: {
    navBar
  },
    data(){
        return{
            returnwhiteicon: require("@/assets/hotel/img/micon/back_cb.png"),
            videoicon:require("@/assets/hotel/img/home/videoplay.png"),
            datainfo:[],
            backups:[],//备份数据
            sum:0,
            seekname:'全部',
            show: false,
            index: 0,
            images: [
                'https://img.yzcdn.cn/vant/apple-1.jpg',
                'https://img.yzcdn.cn/vant/apple-2.jpg',
            ],
            typename:[],
            startPosition:0,
            url:require("@/assets/hotel/img/home/mda-jkinmhhzqaaaqxt4.mp4"),
            volume:false,
            videoshow:false,
            isroll:false,//判断是否滚动了
            current:0,
            videototal:0,
            playerOptions: {
                playbackRates: [0.5, 1.0, 1.5, 2.0],//倍速控制
                autoplay: false,//是否自动播放
                muted: false,//是否静音播放
                loop: false,//是否循环播放
                preload: "auto",
                language: "zh-CN", //语言，还要引入对应的文件
                aspectRatio: "16:9",//比例
                fluid: true,
                sources: [
                    {
                    type: "",
                    src:require("@/assets/hotel/img/home/mda-jkinmhhzqaaaqxt4.mp4"), //url地址
                    },
                    {type: "",
                    src:require("@/assets/hotel/img/home/mda-jkinmhhzqaaaqxt4.mp4"), //url地址
                    }
                ],
                poster: "", //你的封面地址
                notSupportedMessage: "此视频暂无法播放，请稍后再试",
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,//剩余时间是否显示
                    remainingTimeDisplay: false,//剩余时间是否显示，有一个即可
                    fullscreenToggle: true,//全屏按钮
                },
            },
            longitude:'',
            latitude:'',
            raisePrice:'',
            client:10,
            belowHeight:''
        }
    },
    mounted(){
        setTimeout(()=>{
            this.belowHeight=(document.getElementById('type_boxid').clientHeight+110)/10;
            console.log(this.belowHeight,"wwwwwwwwwwwwwwwww");
        },500)
        if (this.$route.query.token) {
            this.$api.setToken(this.$route.query.token);
        }
        // window.addEventListener("scroll", this.scrollToTop,true);
        // sessionStorage.setItem("longitude", "116.481777");
        // sessionStorage.setItem("latitude", "39.910844");
        let coordinate=sessionStorage.getItem("coordinate");
        this.longitude =JSON.parse(coordinate).longitude //sessionStorage.getItem("longitude");
        this.latitude = JSON.parse(coordinate).latitude //sessionStorage.getItem("latitude");
        if(this.$route.query.hotel_id&&this.$route.query.raisePrice){
            this.raisePrice=this.$route.query.raisePrice;
        }
        getOfficialimgData({hotel_id:this.$route.query.hotel_id?this.$route.query.hotel_id:776692,longitude:this.longitude,latitude:this.latitude}).then((res)=>{
            let data=res.pictures.official
            let arr=[];let that=this;
            for (const key in data) {
                that.sum=that.sum+data[key].length
                if(data[key].length>0){
                    let name='';
                    switch (key) {
                        case 'video':
                            name='视频'
                            break;
                        case 'appearance':
                            name='外观';
                            break;
                        case 'public_area':
                            name='公共区域';
                            break;
                        case 'facility':
                            name='健身娱乐设施';
                            break;
                        case 'catering':
                            name='餐饮';
                            break;
                        case 'room':
                            name='房间';
                            break;
                        case 'all':
                            name='360全景图片维护';
                            break;
                        case 'courtyard':
                            name='院子';
                            break;
                        case 'google':
                            name='Google地图图片';
                            break;
                        case 'long':
                            name='眺望远景';
                            break;
                        case 'room_bed':
                            name='酒店房型';
                            break;
                        case '会议室':
                            name='会议室';
                            break;
                        case 'other':
                            name='其他';
                            break;
                        default:
                            break;
                    }
                    arr.push({name:name,value:data[key]})
                }
            }
            this.datainfo=arr;
            this.backups=arr;
        });
    },
    methods:{
        deductionUA() {
            const ua = navigator.userAgent.toLowerCase();
            if (/iphone|ipad|ipod/.test(ua)) {
                this.client = 11;
            } else if (/android/.test(ua)) {
                this.client = 10;
            }
        },
        //返回上一页
        goback() {
            this.$router.go(-1);
        },
        scrollToTop() {
        　　var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if(scrollTop>100){
                this.isroll=true
            }else{
                this.isroll=false
            }
        },
        tab(name){
            this.seekname=name;
            if(name!='全部'){
                let arr=[];
                this.backups.map(res=>{
                    if(res.name==name){
                        arr.push(res);
                    }
                })
                this.datainfo=arr;
            }else{
               this.datainfo=this.backups;
            }
        },
        onChange(index) {
            this.index = index;
        },
        onChanges(index){
            this.current=index;
        },
        videofy(data){
            this.videototal=data.length;
            this.videoshow=true;
            let that=this;let arr=[]
            data.map((res)=>{
                that.playerOptions.sources=[{type:'',src:res.URL}]
                arr.push(that.playerOptions);
            });
        },
        magnify(data,item){
            if(this.seekname=='全部'){
                let arr=[];let name=[];
                this.backups.map(res=>{
                    res.value.map(ress=>{
                        arr.push(ress);
                        name.push(res.name);
                    })
                })
                this.images=arr;
                this.typename=name;
            }else{
                this.images=data;
                let name=[];let that=this;
                data.map(res=>{
                    name.push(that.datainfo[0].name);
                })
                this.typename=name;
            }
            this.images.map((res,i)=>{//指定初始位置
                if(res==item){
                    this.startPosition=i
                }
            })
            this.show=true;
            // 'https://img.yzcdn.cn/vant/apple-1.jpg','https://img.yzcdn.cn/vant/apple-1.jpg'
            // ImagePreview({images:[require("@/assets/hotel/img/home/mda-jkinmhhzqaaaqxt4.mp4")],closeable: true});
        }
    }
}
</script>

<style lang="less">
html{
        font-size: calc(var(--sizeScale2)*10px);
    }
.lookimg_main{
    background: #FBFBFB;
    height: 100%;
    .fixation{
        position: fixed;
        top:0rem;
        width: 100%;
        z-index: 999;
        .nav .nav-title span{
            font-weight: 500;
        }
    }
    .main_tops {
        padding-top: 4.4rem;
        // height: 7.5rem;
        font-size: 1.6rem;
        background: #ffffff;
        box-shadow: 0rem 0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1);
        .type_box{
            padding: 0.7rem;
            box-sizing: border-box;
            .type_item{
                display: inline-block;
                padding: 0.8rem 1.0rem;
                box-sizing: border-box;
                color: #333333; 
                font-size: 1.4rem;
                // font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 400;
                background: #EEEEEE;
                border-radius: 1.8rem;
                margin: 0 0.6rem 1.0rem 0;
            }
            .active{
                color: #ffffff;
                background: #108B30;
            }
        }
    }
    .main_box{
        padding: 1.0rem 1.5rem 0rem 1.5rem;
        box-sizing: border-box;
        // display: flex;
        .title{
            font-size: 1.6rem;
            // font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            margin-bottom: 1.0rem;
        }
        .imgbox{
            position: relative;
            display: inline-block;
            // width: 16.5rem;
            width: 44vw;
            height: 44vw;
            // text-align: center;
            // height: 165rem;
            // width: 140rem;
            // height: 140rem;
            .videoplay{
                position: absolute;
                top:40%;
                left:40%;
                width: 4.0rem;
                height: 4.0rem;
            }
            .main_img{
                width: 100%;
                height: 100%;
                // width: 14.0rem;
                // height: 14.0rem;
                border-radius: 1.0rem;
                margin-bottom: 1.0rem;
            }
        }
        .imgbox:nth-child(even){
            margin-right: calc((100vw - 88vw - 3.0rem));
            // margin-right: 1.0rem;
        }
    }
    .main_boxs{
        padding-top:17.0rem;
    }
    .main_boxss{
        padding-top: 21.0rem;
    }
    .main_boxb{
        // margin-bottom: 5.5rem;
        padding-bottom: 8.5rem;
    }
    .main_bottom{
        // position: sticky;
        position: fixed;
      bottom: 0rem;
      left:0rem;
      right: 0rem;
      background: #ffffff;
        box-shadow: 0rem -0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1);
        .bottom_item{
            display: inline-block;
            padding: 0.5rem 1.5rem 3.0rem 1.5rem;
            box-sizing: border-box;
            color: #FF6253;
            font-size: 1.2rem;
            .num{
                font-size: 2.4rem;
                font-weight: 600;
                margin-right: 0.5rem;
            }
            .tip{
                color: #999999;
            }
        }
        .van-button--normal{
            float: right;
            padding: 1.2rem 2.7rem;
            box-sizing: border-box;
            font-size: 1.6rem;
            // font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            background: linear-gradient(135deg, #FF7742 0%, #FF5A4B 100%);
            border-radius: 2.3rem;
            position: relative;
            top:0.6rem;
            right:1.0rem;
        }
    }
    .van-image-preview__index{
        position: absolute;
        left:0rem;bottom:1.6rem;
        top:auto;
        transform:none;
        box-sizing: border-box;
        display:flex;width:100%;
        .title,.page{
            display: inline-block;
            flex: 1;
            font-size: 1.6rem;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
        }
        .title{
            position: absolute;
            left:2.0rem;
            bottom:0rem;
        }
        .page{
            text-align: center;
            position: absolute;
            right:2.0rem;
            bottom: 0rem;
            label{
                font-size: 2.2rem;
            }
            }
    }
    .van-image-preview__cover{
        position: absolute;
        right:2.0rem;
        top:1.6rem;
        color: #FFFFFF;
        text-align: right;
        font-size: 2.0rem;
    }
    .van-popup--center{
        width: 100%;
        .van-swipe-item{
            // width: 100% !important;
        }
    }
    .videopop{
        position: sticky;
        bottom:2.0rem;
        left:2.0rem;
        z-index: 3000;
        color: #FFFFFF;
        .title,.page{
            display: inline-block;
            flex: 1;
            font-size: 1.6rem;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
        }
        .title{
            position: absolute;
            left:2.0rem;
            bottom:0rem;
        }
        .page{
            text-align: center;
            position: absolute;
            right:2.0rem;
            bottom: 0rem;
            label{
                font-size: 2.2rem;
            }
            }
    }
    .close{
        position: absolute;
        top:2.0rem;
        right: 2.0rem;
        z-index: 3000;
        color: #FFFFFF;
        font-size: 2.0rem;
    }
    .van-overlay{//视频弹窗的背景色
        background: rgba(0,0,0,1);
    }
    .vjs-custom-skin > .video-js .vjs-big-play-button{
        height: 1.5em !important;
        line-height: 1.5em !important;
        background-color:rgba(0,0,0,0.7);
        border-radius:35%;
    }
    .video-js .vjs-big-play-button{
        width: 1.5em;
        border:none;
    }
    .vjs-custom-skin > .video-js .vjs-big-play-button{
        margin-left: -0.8em;
    }
}
</style>